import React from 'react';
import { useCollapse } from 'react-collapsed';
import { IoMdAdd, IoMdRemove } from 'react-icons/io';
import { Flex, Flexed } from '../css/Shared'

// Your custom Collapse component
function Collapse(props) {
  const config = {
    defaultExpanded: props.defaultExpanded || false,
    collapsedHeight: props.collapsedHeight || 0,
  };
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);

  return (
    <div className="collapsible">
      <div className="header" {...getToggleProps()}>
        <Flexed alignItems="center">
          <Flexed flex=".1">
            {isExpanded ? (
              <IoMdRemove
                style={{
                  paddingTop: '5px',
                  fontSize: 'calc(1.3rem + .4vw)',
                  color: 'green',
                  fontWeight: 'bold',
                }}
              />
            ) : (
              <IoMdAdd
                style={{
                  paddingTop: '5px',
                  fontSize: 'calc(1.3rem + .4vw)',
                  color: 'green',
                  fontWeight: 'bold',
                }}
              />
            )}
            {props.title}
          </Flexed>
        </Flexed>
      </div>
      <div {...getCollapseProps()}>
        <div className="content" style={{ margin: '0', padding: '0' }}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

// Reusable CollapseItem component
const CollapseItem = ({ title, children }) => {
  return (
    <Collapse title={title}>
      <Flexed
        flexDirection="column"
        style={{ lineHeight: '1rem', paddingTop: '8px', paddingLeft: '30px' }}
      >
        {children}
      </Flexed>
    </Collapse>
  );
};


export default Collapse;